import React from "react";
import Messages from "./Message";




const ReceivedMessages = () => {

    return (

        <div>
            <Messages />
        </div>

    );
}
export default ReceivedMessages;